import { render, staticRenderFns } from "./governmentInfo.vue?vue&type=template&id=32151a16&scoped=true&"
import script from "./governmentInfo.vue?vue&type=script&lang=js&"
export * from "./governmentInfo.vue?vue&type=script&lang=js&"
import style1 from "./governmentInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32151a16",
  null
  
)

export default component.exports